import { RNG } from "rot-js";
import { gameData, sortWandByVowelFirst } from "../../GameManager";
import { addLetters } from "../../words/letters";
import { WordResult } from "../../words/wordUtils";
import { Actor } from "../Actor";
import { getRampValue } from "../Ramp";

export default {
  wordRegeneration: (
    actor: Actor,
    options: Record<number, number>,
    { wordInfo, noTriggers }: { wordInfo: WordResult; noTriggers: boolean }
  ) => {
    if (!noTriggers) {
      addLetters(actor, getRampValue(options, wordInfo.word.length) || 0);
      if (gameData.wandSorted) {
        sortWandByVowelFirst();
      }
    }
  },

  wordHunger: (
    actor: Actor,
    options: Record<number, number>,
    { wordInfo }: { wordInfo: WordResult }
  ) => {
    let max = wordInfo.word.length;
    wordInfo.crosses?.forEach((c) => {
      if (max < c.word.length) {
        max = c.word.length;
      }
    });

    const amount = getRampValue(options, max);

    if (amount) {
      actor.hunger.change(amount);
    }
  },
};
